import { z } from 'zod'

/**
 * System Health contract (Screen 7). Pinned to the backend's GET
 * /api/health/status response — built to this exact shape in parallel.
 *
 * The server owns each check and returns them in display order (8 checks). This
 * screen only maps status → icon/colour and renders; it never recomputes health.
 * `link` is an in-app route ("/active", "/audit") or null. `detail` is optional
 * extra context (last error, timestamps) shown when expanded.
 */

export const healthStatusSchema = z.enum(['ok', 'warn', 'error', 'info'])
export type HealthStatus = z.infer<typeof healthStatusSchema>

export const healthCheckSchema = z.object({
  key: z.string(),
  label: z.string(),
  status: healthStatusSchema,
  summary: z.string(),
  detail: z.string().nullable(),
  link: z.string().nullable(),
})
export type HealthCheck = z.infer<typeof healthCheckSchema>

export const healthResponseSchema = z.object({
  checks: z.array(healthCheckSchema),
  generated_at: z.string(),
})
export type HealthResponse = z.infer<typeof healthResponseSchema>
